<template>
  <v-data-table
    ref="table"
    v-model="selected_items"
    v-bind="bind"
    calculate-widths
    class="elevation-0 vueti-table table main__light_green"
    :class="tableClass"
    disable-pagination
    :expanded.sync="expanded_items"
    :fixed-header="fixed_header"
    :headers="headers"
    hide-default-footer
    :hide-default-header="hide_default_header"
    :item-key="item_key"
    :items="items"
    :loading="loading"
    :loading-text="$t('Tenders.Loading')+(percentLoading !== null ? ` ${percentLoading}%` : '')"
    :no-data-text="$t('Tenders.NoData')"
    :no-results-text="$t('Tenders.NoData')"
    :single-expand="single_expand"
    @toggle-select-all="toggleSelectAll ? toggleSelectAll : ''">
    <!-- слот хедера -->
    <template
      v-if="hide_default_header"
      #header="{ props, on }">
      <slot
        :headers="headers"
        name="header"
        :on="on"
        :props="props"/>
    </template>
    <!-- всі слоти th хедера за value в хедері -->
    <template
      v-for="(header, i ) in headers"
      #[`header.${header.value}`]>
      <slot
        :header="header"
        :headers="headers"
        :name="`header.${header.value}`">
        <span
          v-if="header.required"
          :key="`red-star-${i}`"
          class="h9-text h5-headline secondary__red--text">*</span>
        {{ header.text }}
      </slot>
      <ResizeColumnDiv
        :key="i"
        ref="resize_column"
        resize_all_tables
        :value="header.value"
        @mouseup="(val, width) => $emit('resizeMouseup', val, width)"/>
    </template>
    <!-- слот th хедера  з селдлектом -->
    <template #[`header.data-table-select`]="{ props, on }">
      <sCheckbox
        class="mx-auto"
        :indeterminate="props.indeterminate"
        :value="props.value"
        @input="on.input"/>
    </template>
    <!-- слот рядка - tr  -->
    <template #item="{ expand: expandF , index, item, isExpanded, isSelected, select}">
      <slot
        :expand="(val) => expandItem(expandF, item, val)"
        :headers="headers"
        :index="index"
        :is-expanded="isExpanded"
        :is-selected="isSelected"
        :item="item"
        name="item-tr"
        :select="select">
        <!-- компонент окремого рядка - tr з можливостю відлідковувати скрол ( IntersectionObserver ) //todo не досконало працює з сортуваннням -->
        <TableTr
          :can_expand="expand"
          :expand="(val) => expandItem(expandF, item, val)"
          :headers="headers"
          :index="index"
          :is-expanded="isExpanded"
          :is-selected="isSelected"
          :item="item"
          :item_id="item_key"
          :select="select"
          :wait_load="wait_tr_load">
          <template #row="{ loaded }">
            <!-- слот в середині рядка з компонента - tr з можливостю відлідковувати скрол ( IntersectionObserver ) //todo не досконало працює з сортуваннням -->
            <slot
              :expand="(val) => expandItem(expandF, item, val)"
              :headers="headers"
              :index="index"
              :is-expanded="isExpanded"
              :is-selected="isSelected"
              :item="item"
              :loaded="loaded"
              name="row"
              :select="select"/>
          </template>
          <!-- слоти по td за header.value в середині рядка з компонента - tr з можливостю відлідковувати скрол ( IntersectionObserver ) //todo не досконало працює з сортуваннням -->
          <template
            v-for="(header) in headers"
            #[`item.${header.value}`]="{ loaded }">
            <slot
              :header="header"
              :headers="headers"
              :index="index"
              :is-expanded="isExpanded"
              :is-selected="isSelected"
              :item="item"
              :loaded="loaded"
              :name="`item.${header.value}`"
              :select="select"/>
          </template>
        </TableTr>
      </slot>
    </template>
    <template #expanded-item="{ item }">
      <tr
        class="table-expanded-row"
        data-qa="table-expanded-row">
        <slot
          :headers="headers"
          :item="item"
          name="expanded-item"/>
      </tr>
    </template>
    <template #[`body.append`]>
      <slot name="body.append"/>
    </template>
    <template v-slot:loading>
      <slot name="loading"/>
    </template>
  </v-data-table>
</template>
<script>
import TableTr from 'components/common/blocks/table/TableTr.vue'
import ResizeColumnDiv from 'components/common/blocks/table/ResizeColumnDiv.vue'
// https://vuetifyjs.com/en/api/v-data-table/

export default {
  name: 'vuetiTable',
  props: {
    /**
     * позиції для відображення
     */
    items: Array,
    /**
     * Масив об’єктів, кожен з яких описує стовпець заголовка
     * приклад для визначення всіх властивостей з вьюті
     * @example {
        text: string,
        value: string,
        align?: 'start' | 'center' | 'end',
        sortable?: boolean,
        filterable?: boolean,
        groupable?: boolean,
        divider?: boolean,
        class?: string | string[],
        cellClass?: string | string[],
        width?: string | number,
        filter?: (value: any, search: string, item: any) => boolean,
        sort?: (a: any, b: any) => number,
        required?: boolean - required-star in header
      }
     */
    headers: Array,
    /**
     * Властивість кожного елемента, яка використовується як унікальний ключ
     */
    item_key: {
      type: String,
      default: 'id'
    },
    /**
     * приховати дефолтний хедер - для заміни на слот
     */
    hide_default_header: {
      type: Boolean,
      default: false
    },
    /**
     * Виправлений заголовок у верхній частині таблиці
     */
    fixed_header: {
      type: Boolean,
      default: false
    },
    /**
     * признак можливого рогортання
     */
    expand: {
      type: Boolean,
      default: false
    },
    /**
     * Масив розгорнутих елементів
     */
    expanded: {
      type: Array,
      default: () => []
    },
    /**
     * розгортання тільки одного рядка
     */
    single_expand: {
      type: Boolean,
      default: false
    },
    /**
     * Функція для розгортання елементів
     */
    expandRow: {
      type: Function,
    },
    /*
      функція власного сортування якшо потрібно
    */
    customSort: {
      type: Function,
      // default: items => items
    },
    /**
     * Масив обраних елементів
     */
    selected: {
      type: Array,
      default: () => []
    },
    /*
      викликається, коли клацнути checkbox «Вибрати все» у заголовку таблиці. Цей checkbox увімкнено параметром show-select
    */
    toggleSelectAll: {
      type: Function,
    },
    wait_tr_load: Boolean,
    tableClass: {
      type: String
    },
    loading: {
      type: Boolean,
    },
    percentLoading: {
      type: [Number, String],
    }
  },
  mounted() {
    this.updateResizeble()
  },
  computed: {
    bind() {
      let bind = {}
      if ( this.customSort ) {
        bind.customSort = this.customSort
      }
      return bind
    },
    expanded_items: {
      get() {
        return this.expanded
      },
      set(value) {
        this.$emit('update:expanded', value)
      }
    },
    selected_items: {
      get() {
        return this.selected
      },
      set(value) {
        this.$emit('update:selected', value)
      }
    },
  },
  methods: {
    expandItem (func, item, val) {
      if (!this.expand ) { return }
      if ( this.expandRow ) {
        this.expandRow(item)
        return
      }
      func(val)
    },
    updateResizeble() {
      this.$refs.resize_column.forEach(element => {
        element.$el.style.height = this.$el.offsetHeight - 5 + 'px'
      })
    }
  },
  components: {
    TableTr,
    ResizeColumnDiv
  }
}
</script>
<style lang="scss">
.vueti-table.v-data-table {
  &, .v-data-table__wrapper {
    border-radius: 10px;
  }
  .v-data-table__wrapper {
    background-color: var(--v-main__green-base) !important;
    padding-bottom: 5px !important;

    table {
      // min-width: 1230px;
      thead  {
        tr {
          max-height: 40px;
          min-height: 40px;
          height: 40px;
          th {
            background-color: var(--v-secondary__green_chosen-base) !important;
            color:var(--v-secondary__green_not_active-base);
            font-weight: 500;
            height: 40px;
            font-size: 11px !important;
            text-transform: uppercase;
            position: relative;
            &.sortable:not(.active) {
              .resize-column:hover ~ .v-data-table-header__icon {
                opacity: 0 ;
              }
            }
            // position: sticky;
            // top: 0;
            // z-index: 5;
          }
        }
        .v-data-table-header__icon  {
          font-size: 15px !important;
          margin-bottom: 2px;
          height: 15px;
        }
      }

      thead, tbody {
        tr {
          min-height: 48px !important;
          th, td  {
            min-height: 48px !important;
            // min-width: min-content !important;
            border-bottom: thin solid var(--v-main__green-base)  !important;
            &:not(:last-child) {
              border-right: thin solid var(--v-main__green-base)  !important;
            }
            //&:not(:first-child) {
            //  padding: 10px !important;
            //}
          }
        }
      }

      tbody tr {
        td {
          color: var(--text-color)  !important;
          font-size: 14px;
          line-height: 18px;
          padding: 10px;
          background-color: var(--v-main__light_green-base) !important;
          &:not(.sForm-cell-error) {
            border-bottom: thin solid var(--v-main__green-base) !important;
          }
        }

        &:last-child {
          td:last-child {
            border-bottom-right-radius: 8px;
          }
          td:first-child {
            border-bottom-left-radius: 8px;
          }
        }

        &.table-expanded-row, &.table-expanded {
          &, td{
            background-color: var(--v-secondary__green_chosen-base) !important;
          }
        }
        &.table-expanded {
          td {
            border-bottom: none !important;
          }
        }
        &.table-expanded-row {
          td {
            border-right: none !important;
          }
        }
      }

    }
  }
}
</style>
